import {NgModule} from "@angular/core";

import {CerbaCommonModule} from "@common/cerba-common.module";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";

import {AppComponent} from "./app.component";
import {CerbaRoutingModule} from "./pages/cerba/cerba.router";

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    CerbaCommonModule,
    BrowserAnimationsModule,
    CerbaRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-paiement-factures/digicerba-paiement-factures-web/src/angular/cerba/src/app/app.module.ts